import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function MethodSection() {
  return <section className="py-20 px-4 sm:px-6 bg-brand-primary text-white relative overflow-hidden" data-id="element-72">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-73"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-black opacity-10 rounded-full blur-3xl -ml-20 -mb-20" data-id="element-74"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-76">
          <div className="inline-flex items-center justify-center p-3 bg-white/20 rounded-full mb-6" data-id="element-77">
            <SparklesIcon size={32} className="text-yellow-300" data-id="element-78" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-79">
            El Método de Ensamblaje Modular 2-2-2
          </h2>
          <p className="text-xl md:text-2xl text-white/90 leading-relaxed font-medium max-w-3xl mx-auto" data-id="element-80">
            A diferencia del Meal Prep común, aquí no cocinas platos finales.
            Preparas "módulos" neutros con un sistema de flujo optimizado.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-81">
          {[{
          number: '2',
          text: 'Horas de preparación',
          emoji: '⏱️'
        }, {
          number: '2',
          text: 'Bolsas de Súper',
          emoji: '🛍️'
        }, {
          number: '2',
          text: 'Ollas en uso',
          emoji: '🍲'
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 text-center" data-id="element-82">
              <div className="text-4xl mb-4" data-id="element-83">{item.emoji}</div>
              <div className="text-5xl font-bold mb-2" data-id="element-84">{item.number}</div>
              <div className="text-lg font-medium text-white/90" data-id="element-85">
                {item.text}
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="bg-white text-brand-text rounded-2xl p-6 md:p-8 shadow-xl text-center" data-id="element-86">
          <p className="text-xl md:text-2xl font-bold leading-relaxed" data-id="element-87">
            La magia ocurre al momento de cenar: solo unes las piezas y aplicas
            una "Salsa Mágica". El resultado es una cena fresca, distinta cada
            noche y lista en menos de{' '}
            <span className="text-brand-primary underline decoration-4 underline-offset-4" data-id="element-88">
              5 minutos
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}